module.exports = __webpack_public_path__ + "85bf30896742ac49f2d9d4157725ff7d.png";